// @core/api/endpoints/workflow/delete_credential.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/workflow';

/**
 * Delete credential
 * Deletes a credential and its associated secrets in SecretService.
 */
export async function DeleteCredential(
  credential_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/credentials/:credential_id`;
  requestPath = requestPath.replace(':credential_id', encodeURIComponent(credential_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
